import type {
    NeglectedOrDelinquentAgeModel,
    NeglectedOrDelinquentGenderModel,
    NeglectedOrDelinquentRaceEthnicityModel,
} from './NeglectedOrDelinquentInformationModel';

export const RACE_ETHNICITY_FIELDS: {
    key: keyof NeglectedOrDelinquentRaceEthnicityModel;
    label: string;
}[] = [
    { key: 'americanIndianOrAlaskaNative', label: 'American Indian or Alaska Native' },
    { key: 'asian', label: 'Asian' },
    { key: 'blackOrAfricanAmerican', label: 'Black or African American' },
    { key: 'hispanicOrLatino', label: 'Hispanic or Latino' },
    {
        key: 'nativeHawaiianOrOtherPacificIslander',
        label: 'Native Hawaiian or Other Pacific Islander',
    },
    { key: 'white', label: 'White' },
    { key: 'twoOrMoreRaces', label: 'Two or More Races' },
];

export const GENDER_FIELDS: {
    key: keyof NeglectedOrDelinquentGenderModel;
    label: string;
}[] = [
    { key: 'female', label: 'Female' },
    { key: 'male', label: 'Male' },
];

export const AGE_FIELDS: {
    key: keyof NeglectedOrDelinquentAgeModel;
    label: string;
}[] = [
    { key: 'age3To5', label: '3-5' },
    { key: 'age6', label: '6' },
    { key: 'age7', label: '7' },
    { key: 'age8', label: '8' },
    { key: 'age9', label: '9' },
    { key: 'age10', label: '10' },
    { key: 'age11', label: '11' },
    { key: 'age12', label: '12' },
    { key: 'age13', label: '13' },
    { key: 'age14', label: '14' },
    { key: 'age15', label: '15' },
    { key: 'age16', label: '16' },
    { key: 'age17', label: '17' },
    { key: 'age18', label: '18' },
    { key: 'age19', label: '19' },
    { key: 'age20', label: '20' },
    { key: 'age21', label: '21' },
];
